import { app } from '@/utils'

const observer = {
  install(Vue, options = {}) {
    let IO
    Vue.directive('observer', {
      inserted: function (el, binding) {
        IO = new IntersectionObserver(
          entries => {
            if (entries[0].intersectionRatio <= 0) {
              binding.value(false)
            } else {
              binding.value(true)
            }
          },
          {
            root: document.querySelector('#app'),
            threshold: [0, 0.25, 0.5, 0.75, 1]
          }
        )
        IO.observe(el)
      },
      unbind(el) {
        try {
          IO.unobserve()
        } catch (err) {
          // console.log(err)
        }
      }
    })
  }
}
export default observer
